var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    class: _vm.$style.CCircularTimer,
    style: _setup.wrapperStyles
  }, [_c('svg', {
    class: _vm.$style.svg,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": _setup.viewBoxAttribute
    }
  }, [_c('linearGradient', {
    attrs: {
      "id": _setup.gradientId
    }
  }, _vm._l(_vm.gradient, function (item, index) {
    return _c('stop', {
      key: index,
      attrs: {
        "offset": item.offset,
        "stop-color": item.color
      }
    });
  }), 1), _vm._v(" "), _c('circle', _vm._b({
    class: _vm.$style.firstCircle,
    attrs: {
      "stroke": _setup.firstCircleColor
    }
  }, 'circle', _setup.firstCircleAttributes, false)), _vm._v(" "), _c('circle', _vm._b({
    class: _vm.$style.secondCircle,
    attrs: {
      "stroke": _setup.secondCircleColor
    }
  }, 'circle', _setup.secondCircleAttributes, false))], 1), _vm._v(" "), _c('span', {
    class: _vm.$style.timer
  }, [_c('span', [_vm._v(_vm._s(_setup.timer.hours))]), _vm._v(" "), _c('span', [_vm._v(":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_setup.timer.minutes))])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };